import { render, staticRenderFns } from "./VerifySMSOTP.vue?vue&type=template&id=24eff840&scoped=true"
import script from "./VerifySMSOTP.vue?vue&type=script&lang=js"
export * from "./VerifySMSOTP.vue?vue&type=script&lang=js"
import style0 from "./VerifySMSOTP.vue?vue&type=style&index=0&id=24eff840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24eff840",
  null
  
)

export default component.exports